// Recipe filtering + lazy loading
jQuery(function($) {

    // force reloading on state changes
    $(window).on("popstate", function(e) {
        // 	console.log(e)
        // 	if (e.originalEvent.state !== null) {
        location.reload()
        // }
    })

    if (!$('.community-filter').length) return

    var form = $('.ajax-search')
    var offsetField = form.find('[name="offset"]')
    var categoryfilter = form.find('[name="categoryfilter"]')
    var sort = form.find('[name="sort"]')
    var $response = $('#response')
    var $loadMore = $('.load-more')

    function ajaxFilter(isPagination, cb) {

        $.ajax({
            url: form.attr('action'),
            data: form.serialize(), // form data
            type: form.attr('method'), // POST
            beforeSend: function(xhr) {
                if (!isPagination) {
                    $response.html('<div class="col-lg-3 col-sm-6 recipe-card fake"><div class="inner"><div class="image"></div><div class="meta"></div><div class="title"></div><div class="title2"></div></div></div><div class="col-lg-3 col-sm-6 recipe-card fake"><div class="inner"><div class="image"></div><div class="meta"></div><div class="title"></div><div class="title2"></div></div></div><div class="col-lg-3 col-sm-6 recipe-card fake"><div class="inner"><div class="image"></div><div class="meta"></div><div class="title"></div><div class="title2"></div></div></div><div class="col-lg-3 col-sm-6 recipe-card fake"><div class="inner"><div class="image"></div><div class="meta"></div><div class="title"></div><div class="title2"></div></div></div>');
                }
            },
            success: function(data) {
                // set the laast keyword
                // lastKeyword = keywordfilter.val()

                if (!isPagination) {
                    $response.html(data) // insert data
                    addLoadMoreObserver()
                } 
                else {
                    // if the result has content
                    if (data.length > 2) {
                        $response.html($response.html() + data) // insert data						
                        addLoadMoreObserver()
                    } else {
                        $loadMore.html('')
                    }
                }

                if (typeof cb === 'function') cb()
            }
        })
        return false
    }

    function isOnScreen(elem) {

        var win = $(window)

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };
        viewport.right = viewport.left + win.width()
        viewport.bottom = viewport.top + win.height()

        var bounds = elem.offset()
        bounds.right = bounds.left + elem.outerWidth()
        bounds.bottom = bounds.top + elem.outerHeight()

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom))
    }

    function addLoadMoreObserver() {
        $loadMore.html('')        
        if ($('.none-found').length) return
        
        $loadMore.append('<span class="loading-more text-center btn btn-primary" style="margin:auto">Loading more...</span>')

        lozad('.loading-more', {
            load: function(el) {
                offsetField.val(parseInt(offsetField.val()) + 12)
                ajaxFilter(true)
            }
        }).observe()
    }


    categoryfilter.change(function() {
        offsetField.val(0)
        ajaxFilter()

        // change taxonomy title if available
        if (
            categoryfilter.find(':selected').val() === 'all'
        ) {
            // TODO: move these into a single function
            // $('.page-title').html('Vegan <em>' + categoryfilter.find(':selected').text().toLowerCase() + '</em> recipes')
            var slug = categoryfilter.find(':selected').text()
            slug = slug.trim()
            slug = slug.toLowerCase()
            // history.pushState(null, null, '/recipes/mealtimes/' + slug + '/')
        } 
        else {
            // $('.page-title').html('Vegan & plant-based recipes')
            // history.pushState(null, null, '/recipes/')            
        }
    })

    sort.change(function() {
        offsetField.val(0);
        ajaxFilter();
    })

    addLoadMoreObserver()

    form.submit(function(e) {
        e.preventDefault()

        if (!isOnScreen($('#response')))
            $('html, body').animate({ scrollTop: $('#response').offset().top - 150 }, 1000)

        offsetField.val(0)
        ajaxFilter(false)
    });

});

// manage preferences
jQuery(function($) {
    if (!$('.klaviyo-landing-page-signup').length) return
    var form = $('.klaviyo-landing-page-signup')
    // var message = form.find('.klaviyo_messages');
    form.submit(function() {
        $.ajax({
            url: form.attr('action'),
            data: form.serialize(), // form data
            type: form.attr('method'), // POST
            dataType: "json",
            beforeSend: function(xhr) {
                form.find('.klaviyo_messages').html('').removeClass('error success')
                form.find('[type="submit"]').text('loading...').addClass('disabled').attr('disabled', true)
            },
            success: function(data) {
                console.log(data)
                form.find('.klaviyo_messages').addClass(data.status).html(data.message)
                form.find('[type="submit"]').text('update preferences').removeClass('disabled').attr('disabled', false)
            },
            error: function(err) {
                console.log(err)
            }
        });
        return false;
    });

});